// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"dec4c112","4078":"c481ccaa","5918":"ea1f6f3a"}[chunkId] + ".chunk.css";
};